import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { hideModal } from '../../../actions/modalsActions';
import { updateItem } from '../../../actions/relationActions';
import CyberSecurity from '../../../apis/cyberSecurityData';
import "react-datepicker/dist/react-datepicker.css";
import AdminForm from './AdminForm';

let AddRelatedStory = (props) => {
    //redux
    const accessToken = useSelector(state => state.accessToken);
    const currentUser = useSelector(state => state.currentUser);
    //local
    const [error, setError] = useState('');
    const [initialValues, setInitialValues] = useState(null);

    const getInitialValues = async () => {
        try {
            const response = await CyberSecurity.get(`/itemdata/${props.item._id}`, {
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            })

            const item = response.data;

            setInitialValues({
                mainCategory: 'Stories',
                subCategory: item.subCategory,
                industry: item.industry,
                image: require('../../../images/PlaceHolderImage.jpg'),
                searchTags: item.searchTags,
                mainCategoryType: 'CYBER STORY',
                newTag1: currentUser.firstName + ' ' + currentUser.lastName,
                newTag2: item.industry.join(', '),
                newTag3: item.subCategory.join(', '),
                newTag5: 'Article',
                newTag6: getDate(new Date()),
                exactDate: new Date(),
                slideTitle: item.newTag4,
                tileTop: item.subCategory.join(', ') + ' - ' + item.newTag4,
                radioButtonsDisabled: true
            })

        } catch (error) {

        }
    }

    useEffect(() => {
        getInitialValues();
    }, [])


    const onSubmit = async (relatedItem) => {

        // 1. check for existeing item with the same url1
        // the following request will respond with the number of items in the database with the url1 of the entered item in the form
        const urlResponse = await CyberSecurity.get('/checkurlexist', {
            params: {
                url1: relatedItem.url1
            },
            headers: {
                Authorization: `Bearer ${props.accessToken}`
            }
        })

        //checking the count of the items in the database with the same url
        //if the count is > 0 that means there is an existing item with the same url
        if (urlResponse.data.count > 0) {
            //code here will run if there is an existing item with the same url
            setError('Item with the same url is allready exists')

        } else {
            //code here will run when there is no exist item with the same url
            setError('')

            const response = await CyberSecurity.post('/addrelateditem', { relatedItem, item: props.item }, {
                headers: {
                    Authorization: `Bearer ${props.accessToken}`
                }
            })

            if (response.data.error) return console.log({ error: response.data.error })

            props.updateItem(response.data)
            props.hideModal();
        }

    }

    if (initialValues) return (
        <div>
            <AdminForm initialValues={initialValues} onFormSubmit={onSubmit} />
            <h3 style={{ color: 'red' }}>{error}</h3>
        </div>
    )
    else return null;
}

function getDate(date) {
    var a = new Date(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var day = a.getDate();
    return (`${month} ${day}, ${year}`)
}


export default connect(null, { hideModal, updateItem })(AddRelatedStory);
